import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { homeRoute } from '@app-constants/app.constants';
import { SubscriptionService } from '@app-services/subscription/subscription.service';

@Component({
  selector: 'app-paymentstatus',
  templateUrl: './paymentstatus.component.html',
  styleUrls: ['./paymentstatus.component.css', '../payment/payment.component.css']
})
export class PaymentstatusComponent implements OnInit {
  PaymentstatusUtility
  routeData
  examtype
  constructor(private router: Router,
              private SubscriptionService: SubscriptionService,
               ) {
    this.routeData = this.router.getCurrentNavigation()?.extras?.state;
    console.log(this.routeData)
    if (!this.routeData || !Object.keys(this.routeData).length) {
      window.location.href = homeRoute
    }

   }
   
   lastDate:any = {
     'neet':{
        '13':['29-October-2021 to 20-April-2022'],
        '12':['15-November-2021 to 15-April-2022' ,'13-December-2021 to 15-April-2022'],
        '11':['15-November-2021 to 15-April-2022' ,'13-December-2021 to 15-April-2022'],
     },
     'jee':{
      '13':['29-October-2021 to 20-April-2022'],
      '12':['15-November-2021 to 15-April-2022' ,'13-December-2021 to 15-April-2022'],
      '11':['15-November-2021 to 15-April-2022' ,'13-December-2021 to 15-April-2022'],
     }
   }

  ngOnInit(): void {
    if (!Object.keys(this.routeData).length) {
      window.location.href = homeRoute
    }
  }
  downloadInvoice(){
    this.SubscriptionService.downloadInvoice(this.routeData?.payment?.userOrder?.id).subscribe((resp:any)=>{
      const a = document.createElement('a')
      const objectUrl = URL.createObjectURL(resp)
      a.href = objectUrl
      a.download = this.routeData?.examName  ? this.routeData?.examName+'invoice' : this.routeData?.examname ? this.routeData?.examname+'invoice' :'invoice';
      a.click();
      URL.revokeObjectURL(objectUrl)

    })
  }
  retry(){
     this.router.navigate(['/courses/payment'],{state:this.routeData});
  }

}
